class Base64Format {
	static keyDecode(key) {
		return JSON.parse(atob(key))
	}

	static keyEncode(key) {
		return btoa(key)
	}

	/**
	 * Decoupe et decode un JWT.
	 * @returns l'objet {header, body, tail}, ou null si le jeton est absent ou illisible
	 *          (stockage corrompu, ancien format, edition manuelle). L'appelant doit traiter
	 *          le null comme une absence de session : sans ce garde-fou, un jeton invalide
	 *          faisait planter l'app au demarrage sur un ecran blanc.
	 */
	static splitToken(token) {
		try {
			const tokenSplit = token?.split('.')
			if (!tokenSplit || tokenSplit.length < 3) return null

			return {
				header: this.keyDecode(tokenSplit[0]),
				body: this.keyDecode(tokenSplit[1]),
				tail: tokenSplit[2],
			}
		} catch (e) {
			return null
		}
	}
}

export default Base64Format
